import { Data } from '../../signup-data/DATA';
import { setIsNewUserCreated } from '../../store/app/action-creators';
import { setUserId } from '../../store/auth/action-creators';
import { httpError, httpSuccess } from '../../store/http-responses/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import AnonymousUsageTrackerContainer from '../../tracking/AnonymousUsageTrackerContainer';
import UsageTrackerContainer from '../../tracking/UsageTrackingContainer';
import { EndpointKey } from '../EndpointKey';
export const handleSignupSuccessChatSpot = ({
  creatorId
}, dispatch, getState) => {
  dispatch(setUserId(creatorId));

  if (AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    UsageTrackerContainer.setProperties({
      email: getSignupDataValue(getState(), Data.Email)
    });
  }

  UsageTrackerContainer.setProperties({
    userId: creatorId
  });
  dispatch(setIsNewUserCreated(true));
};
export const handleSignupResponseChatSpot = response => dispatch => {
  const endpointKey = EndpointKey.Signup;

  if ('creatorId' in response) {
    return dispatch(httpSuccess(endpointKey, response));
  }

  return dispatch(httpError(endpointKey, {
    message: 'Signup Error',
    status: response.status,
    data: response.data
  }));
};